import React from "react";
import "../../css/Tools/Tools.css";

const VirtualTour = () => {
  return (
    <div className="tool-container">
      <div className="tool-content">
        <div className="tool-icon-container">
          <svg
            className="tool-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
        </div>

        <div className="tool-status">
          <svg
            className="tool-status-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Coming Soon
        </div>

        <h1 className="tool-title">Virtual College Tour</h1>

        <p className="tool-message">
          We currently don't offer a virtual college tour tool. However, you can
          explore colleges online by visiting YouVisit's Virtual Tour Page.
        </p>

        <div className="tool-links">
          <a
            href="https://www.youvisit.com/virtual-reality-360-experience"
            className="tool-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="tool-link-text">
              Go to YouVisit's Virtual Tour Page
              <svg
                className="tool-link-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </span>
          </a>
        </div>

        <div className="tool-features">
          <h3 className="tool-features-title">What You'll Experience</h3>
          <ul className="tool-features-list">
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                360° immersive campus experiences
              </span>
            </li>
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Interactive campus maps and building tours
              </span>
            </li>
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Student life insights and campus culture
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VirtualTour;
